export default {
  name: 'marking--treeMrkReportGisMtData',
  apiService: 'shoes',
  apiPath: '/admin/export_file/gis-mt-data',
  urlParamName: 'marking--treeMrkReportGisMtData',
};